module.exports = __webpack_public_path__ + "img/weddings_11_V.d2a96b45.webp";